import { render, staticRenderFns } from "./NewCurrentSaleLine.vue?vue&type=template&id=22b752e5&scoped=true"
import script from "./NewCurrentSaleLine.vue?vue&type=script&lang=js"
export * from "./NewCurrentSaleLine.vue?vue&type=script&lang=js"
import style0 from "./NewCurrentSaleLine.vue?vue&type=style&index=0&id=22b752e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b752e5",
  null
  
)

export default component.exports